
import { MediaMatcher } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  OnDestroy,
  Output,
  signal


} from '@angular/core';
import { MenuItems } from '../../shared/menu-items/menu-items';
import { jwtDecode } from 'jwt-decode';



import { PerfectScrollbarConfigInterface, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { FormControl } from '@angular/forms';
import { AuthService } from '../../core/services/auth/auth.service';
import { WINDOW } from '../../core/tokens/window.token';
import { ApiService } from '../../core/services/common/api.service';
import { FilterStateService } from '../../core/services/common/filter-state.service';
import { AppsettingsService } from '../../core/services/appsettings.service';

/** @title Responsive sidenav */
@Component({
  selector: 'app-full-layout',
  templateUrl: 'full.component.html',
  styleUrls: []
})
export class FullComponent implements OnDestroy {
  mobileQuery: MediaQueryList;
  dir: 'ltr' | 'rtl' | 'auto' = 'ltr';
  minisidebar = false;
  boxed = false;
  showHide = false;
  horizontal = false;
  url = '';
  sidebarOpened = false;
  status = false;
  Tenant = new FormControl('');
  tenants: any = [];
  horizontal1 = signal(true);
  tenantName: string | null = null;

  public showSearch = false;

  public config: PerfectScrollbarConfigInterface = {};
  private _mobileQueryListener: () => void;

  clickEvent() {
    this.status = !this.status;
  }

  constructor(
    public router: Router,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    private apiService: ApiService,
    private filterState: FilterStateService,
    public appsettingsService: AppsettingsService,
    private authService: AuthService,
    @Inject(WINDOW) private window: Window
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 1023px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    // tslint:disable-next-line: deprecation
    this.mobileQuery.addListener(this._mobileQueryListener);
    
  }
  ngOnInit(): void {
    if (!this.appsettingsService.userProfile?.name) {
      this.appsettingsService.getUserProfile();
      if (!this.appsettingsService.userProfile?.name) {
        // Profile was never (or incorrectly) persisted at login — rebuild it
        // from the access token claims.
        this.authService.getToken().subscribe((token) => {
          if (!token) {
            return;
          }
          const claims: any = jwtDecode(token);
          if (claims?.name) {
            this.appsettingsService.setUserProfile({
              name: claims.name,
              preferred_username: claims.preferred_username,
              email: claims.email,
              role: claims.role,
            });
          }
        });
      }
    }
    this.getCustomerList();
    this.Tenant.valueChanges.subscribe((selectedTenantId) => {

      const selectedTenant = this.tenants.find(tenant => tenant.id === selectedTenantId);
      if (selectedTenant) {
        this.tenantName = selectedTenant.customerName;
        this.appsettingsService.setSelectedTenant(selectedTenant);
      } else {
        this.tenantName = null; 
      }
    });

  }
  ngOnDestroy(): void {
    // tslint:disable-next-line: deprecation
    this.mobileQuery.removeListener(this._mobileQueryListener);
    
  }
  getCustomerList() {
    this.apiService.getCustomerList().subscribe(res => {
      this.tenants = res;
      const savedId = Number(localStorage.getItem('ps.selectedTenantId'));
      const savedTenant = this.tenants.find(tenant => tenant.id === savedId);
      this.Tenant.setValue(savedTenant ? savedTenant.id : this.tenants[0]?.id);
    });
  }
  // Drill-down pages don't listen for tenant changes — their content belongs
  // to the context they were opened from. On a tenant switch, bounce them to
  // their section's landing page. Filter/landing pages refresh themselves.
  private readonly sectionLandingRedirects: { pattern: RegExp; landing: string }[] = [
    { pattern: /^\/admin\/instances/, landing: '/admin/manage' },
    { pattern: /^\/analysis\/specifications/, landing: '/analysis/manage' },
    { pattern: /^\/analysis\/(?!manage|analyze)/, landing: '/analysis/analyze' },
    { pattern: /^\/pools\/detail/, landing: '/pools/manage' },
  ];

  onTenantChange(event: any) {
    const selectedTenantId = event.value;
    const selectedTenant = this.tenants.find((tenant) => tenant.id === selectedTenantId);
    if (selectedTenant) {
      localStorage.setItem('ps.selectedTenantId', String(selectedTenantId));
      this.filterState.reset();
      this.appsettingsService.setSelectedTenant(selectedTenant);
      const redirect = this.sectionLandingRedirects.find(r => r.pattern.test(this.router.url));
      if (redirect) {
        this.router.navigate([redirect.landing]);
      }
    }
  }
  Logout = function () {
    const savedTenantId = localStorage.getItem('ps.selectedTenantId');
    this.authService.logoff();
    this.window.sessionStorage.clear();
    localStorage.clear();
    if (savedTenantId) {
      localStorage.setItem('ps.selectedTenantId', savedTenantId);
    }
  }
  get userRoleLabel(): string {
    const role = this.appsettingsService?.userProfile?.role;
    const roles: string[] = Array.isArray(role) ? role : (role ? [role] : []);
    const known = ['admin', 'systemadmin', 'psychometrician', 'dataspecialist', 'viewer'];
    const preferred = roles.find(r => known.includes(String(r).toLowerCase()));
    if (preferred) {
      return preferred;
    }
    // Skip identity-server plumbing claims (demo/admin-tool roles)
    const meaningful = roles.filter(r => !/^myrole$/i.test(r) && !/^skoruba/i.test(r));
    return meaningful[0] || roles[0] || '';
  }

  get userInitials(): string {
    const name = this.appsettingsService?.userProfile?.name || '';
    const initials = name
      .split(/[\s._-]+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part: string) => part[0].toUpperCase())
      .join('');
    return initials || '?';
  }

  horizentalBarUpdation() {
    if (this.horizontal) {
      this.horizontal1.set(!this.horizontal1);
    } else {
      this.horizontal1.set(true);
    }
  }


  // Mini sidebar
}
